import HomeView from '@/views/HomeView.vue'
import Sidebar from '@/components/nav/NavComonents.vue'

export default [
    {
        path: '/systemConfig',
        name: '系统配置',
        meta: {
            title: "系统配置",
        },
        redirect: '/systemConfig/paymentConfig',
        leaf: false, //是否为单节点，增加属性
        menuShow: true,
        component: HomeView,
        icoClass: 'el-icon-user',
        children: [
            {
                path: '/systemConfig/paymentConfig',
                name: "支付配置",
                meta: {
                    title: "支付配置",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/systemConfig/paymentConfig.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/systemConfig/ossStorageConfig',
                name: "OSS存储配置",
                meta: {
                    title: "OSS存储配置",
                    isDestroy: true
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/systemConfig/ossStorageConfig.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/systemConfig/smsConfig',
                name: "短信配置",
                meta: {
                    title: "短信配置",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/systemConfig/smsConfig.vue'),
                    sidebar: Sidebar
                }
            }
        ]
    }
]